import { isAgentApplicationSource } from "@/domain/application"
import { decodeParams } from "@/organisms/Drawers/applications/common/common"
import { useApplicationEntity } from "@/organisms/Drawers/applications/inventory/useInventory"
import { WIDTH_DEFAULT } from "@/organisms/Drawers/const"
import { useDrawer } from "@/organisms/Drawers/hooks/useDrawer"
import { SbomTab } from "../SbomTab"
import { TabsDrawerTemplate } from "../TabsDrawerTemplate"
import { IssueTabApplicationDrawer } from "./components/IssueTabApplicationDrawer"
import { OverviewTabApplicationDrawer } from "./components/OverviewTabApplicationDrawer"
import {
  RUNTIME_ACTIONS_TAB,
  RuntimeActionsTabApplicationDrawer
} from "./components/RuntimeActionsTabApplicationDrawer"
import { TitleApplicationDrawer } from "./components/TitleApplicationDrawer"

import type { ApplicationDrawerComponent } from "."

const TABS = ["overview", "sbom", "scaIssues"]
const COMPONENTS = [
  OverviewTabApplicationDrawer,
  SbomTab,
  IssueTabApplicationDrawer
]

export const ApplicationDrawer: ApplicationDrawerComponent = (props) => {
  const { widthAdditive, ...restProps } = props
  const { searchParams } = useDrawer(restProps.id)
  const recordId = decodeParams(searchParams.get(restProps.id) || "")?.record
    ?.id
  // Same query the overview tab reads, so the application is fetched once
  const [{ response }] = useApplicationEntity(recordId)
  // Only agents (AgentCore, Foundry) have tool calls the runtime sensor reports
  const isAgent = isAgentApplicationSource(
    response?.data?.[0]?.applicationSource
  )
  const tabs = isAgent ? [...TABS, RUNTIME_ACTIONS_TAB] : TABS
  const components = isAgent
    ? [...COMPONENTS, RuntimeActionsTabApplicationDrawer]
    : COMPONENTS

  return (
    <TabsDrawerTemplate
      name="ApplicationDrawer"
      tabs={tabs}
      components={components}
      Title={TitleApplicationDrawer}
      width={WIDTH_DEFAULT + widthAdditive}
      {...restProps}
    />
  )
}
